// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"491":"6b2bfb27","933":"dadef004","991":"c7b965e5"}[chunkId] + ".chunk.js";
};